module.exports = __webpack_public_path__ + "static/media/leaf.3aaf2f61.svg";